import { Link as RouterLink } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import MainImageCardDashboard from '../../../components/Cards/MainImageCardDashboard';
import HeaderCardSmall from "../../../components/Header/HeaderCardSmall";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { eyes } from "../../../constants";


export default function EyesCard() {

return (
<>

    <MainImageCardDashboard

        content = {<HeaderCardSmall cardheadline={'Eye Health'} /> }

        iconbuttons = {<>               

                        <Tooltip title="Eyes Health" placement="bottom">
                                <IconButton component={RouterLink} to="/EyesWelcome"  size="large">
                                        <VisibilityOutlinedIcon sx={{color: 'common.white', '&:hover': { color: 'primary.light'}, }}/>
                                </IconButton>
                        </Tooltip>               
                 </>}  

        photo = { eyes }  

    />

</>
)};
